module.exports = __webpack_public_path__ + "media/images/emblems/Wauwil_LU-a5d5e7f306b00896fe6da45b5a598fed.png";